import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  Label,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';

import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { sortPropertyListByName } from '../../../../../../helpers/Utils';
import {
  gAPI_Property_List_By_Group,
  API_Whatsapp_Integration,
  API_Whatsapp_Integration_Group,
  postAPI_Whatsapp_Integration_Group,
} from '../../../../../../constants/APIs';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Validation from '../../../../../../components/Validation';
export default function WhatsappIntegration({ visible, toggle, id }) {
  const [property, setProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [inputData, setInputData] = useState({
    groupId: getGroupID(),
    name: '',
    propertyId: '',
    sessionTimeoutInSeconds: 600,
    defaultLanguage: 'en-US',
    phoneNumber: '',
    messageService: '',
    accountSID: '',
    authToken: '',
  });
  const [serviceURLEndpoint, setServiceURLEndpoint] = useState('');
  const [linkCopied, setLinkCopied] = useState(false);

  useEffect(() => {
    if (id !== undefined) {
      const url =
        process.env.REACT_APP_CHAT_API +
        `/whatsapp?iid=${id}&groupId=${getGroupID()}`;
      setServiceURLEndpoint(url);
      AxiosAPI({
        method: 'get',
        url: `${API_Whatsapp_Integration}/${id}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          // console.log(res.data)
          setInputData({
            ...inputData,
            name: res.data.name,
            propertyId: res.data.properties[0],
            phoneNumber: res.data.channelDetails.phoneNumber,
            accountSID: res.data.channelDetails.accountSID,
            authToken: res.data.channelDetails.authToken,
            messageService: res.data.channelDetails.messageService,
          });
        })
        .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    }
  }, [id]);

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handlePhoneNumberChange = (e) => {
    e.persist();
    setInputData({ ...inputData, phoneNumber: e.target.value });
    //console.log(inputData)
  };

  const handleAccountSIDChange = (e) => {
    e.persist();
    setInputData({ ...inputData, accountSID: e.target.value });
    //console.log(inputData)
  };
  const handleAuthTokenChange = (e) => {
    e.persist();
    setInputData({ ...inputData, authToken: e.target.value });
    //console.log(inputData)
  };
  const handleMessageServiceChange = (e) => {
    e.persist();
    setInputData({ ...inputData, messageService: e.target.value });
    //console.log(inputData)
  };

  const handleCheckChange = (e) => {
    if (e.target.checked) {
      setInputData({ ...inputData, propertyId: e.target.value });
    }
    if (!e.target.checked) {
      setInputData({ ...inputData, propertyId: '' });
    }
  };

  const handleSave = async () => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_Whatsapp_Integration_Group}?phone_number=${inputData.phoneNumber}`,
      }).then((res) => {
        let forceRefresh = {
          updater: 'Dashboard',
          refresh: true,
          phoneNumber: inputData.phoneNumber,
        };
        AxiosAPI({
          method: 'put',
          url: `${API_Whatsapp_Integration}/${id}?group_id=${getGroupID()}`,
          data: inputData,
        }).then(() =>
          AxiosAPI({
            method: 'put',
            url: `${API_Whatsapp_Integration_Group}/${res.data.id}`,
            data: forceRefresh,
          }).then(() => {
            setTimeout(() => {
              window.location.reload();
            }, 300);
          })
        );
        toggle();
      });
    } else {
      let groupWhatsAppRequest = {
        groupId: getGroupID(),
        propertyId: inputData.propertyId,
        phoneNumber: inputData.phoneNumber,
        creator: 'Dashboard',
      };
      AxiosAPI({
        method: 'post',
        url: API_Whatsapp_Integration,
        data: inputData,
      }).then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          setMsg(res.data.Messages);
          setOpen(true);
        } else {
          groupWhatsAppRequest.integrationId = res.data.id;

          AxiosAPI({
            method: 'post',
            url: `${postAPI_Whatsapp_Integration_Group}`,
            data: groupWhatsAppRequest,
          }).then(() =>
            setTimeout(() => {
              window.location.reload();
            }, 300)
          );
        }
      });
      toggle();
    }
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>
                  {id === undefined ? 'Add' : 'Update'} Whatsapp Integration
                </h6>
                <Separator className="mb-3" />
                <Form>
                  <FormGroup className="text-left mb-2">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="name"
                      onChange={handleNameChange}
                      placeholder="Integration Name"
                      defaultValue={inputData.name}
                    />
                  </FormGroup>
                  <FormGroup className="text-left mb-2">
                    <Label>Phone Number</Label>
                    <Input
                      type="text"
                      name="phoneNumber"
                      onChange={handlePhoneNumberChange}
                      placeholder="+[country code][area code][phone number]"
                      defaultValue={inputData.phoneNumber}
                    />
                  </FormGroup>
                  <FormGroup className="text-left mb-2">
                    <Label>Account SID</Label>
                    <Input
                      type="text"
                      name="accountSID"
                      onChange={handleAccountSIDChange}
                      placeholder="Account Sid can be found in your Twilio account settings"
                      defaultValue={inputData.accountSID}
                    />
                  </FormGroup>
                  <FormGroup className="text-left mb-2">
                    <Label>Auth Token</Label>
                    <Input
                      type="text"
                      name="authToken"
                      onChange={handleAuthTokenChange}
                      placeholder="Auth Token can be found in your Twilio account settings"
                      defaultValue={inputData.authToken}
                    />
                  </FormGroup>
                  <FormGroup className="text-left mb-2">
                    <Label>Service Id</Label>
                    <Input
                      type="text"
                      name="messageService"
                      onChange={handleMessageServiceChange}
                      placeholder="Service Id can be found in your Twilio account settings"
                      defaultValue={inputData.messageService}
                    />
                  </FormGroup>
                  <FormGroup className="text-left mb-2">
                    <Label>Service Endpoint Url</Label>
                    <Input
                      type="text"
                      name="serviceurl"
                      placeholder={
                        serviceURLEndpoint === ''
                          ? 'Service endpoint url will be available after you save'
                          : ''
                      }
                      defaultValue={serviceURLEndpoint}
                      disabled
                    />
                    {serviceURLEndpoint !== '' && (
                      <Fragment>
                        <div className="text-center">
                          <CopyToClipboard
                            text={serviceURLEndpoint}
                            onCopy={() => setLinkCopied(true)}
                          >
                            <Button
                              color="success"
                              size="xs"
                              style={{ marginTop: '10px' }}
                            >
                              Copy the URL
                            </Button>
                          </CopyToClipboard>
                          {linkCopied ? <div>Copied.</div> : null}
                        </div>
                      </Fragment>
                    )}
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <div className="my-2 text-center">
                      <h3>Select your property</h3>
                    </div>
                    <div className="integration-property">
                      {sortPropertyListByName(property).map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="radio"
                            id={index}
                            label={p.name}
                            value={p.id}
                            name="property"
                            checked={
                              p.id === inputData.propertyId ? true : false
                            }
                            onChange={handleCheckChange}
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}

                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
}
